import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { CardHeader, FormFooter } from "@components/molecules";
import { Overlay } from "@components/organisms";
import { Loader } from "@components/atoms";
import * as S from "./styles";

var getCancelBtnProps = function getCancelBtnProps(action, text) {
  return text && {
    cancelBtn: {
      action: action,
      testingContext: "cancelButton",
      text: text
    }
  };
};

var getSubmitBtnProps = function getSubmitBtnProps(text, submitButtonTestingContext, action) {
  return {
    submitBtn: action ? {
      action: action,
      testingContext: submitButtonTestingContext,
      text: text
    } : {
      testingContext: submitButtonTestingContext,
      text: text
    }
  };
};

export var Modal = function Modal(_ref) {
  var cancelBtnText = _ref.cancelBtnText,
      children = _ref.children,
      disabled = _ref.disabled,
      _ref$formId = _ref.formId,
      formId = _ref$formId === void 0 ? "modal-submit" : _ref$formId,
      submitBtnText = _ref.submitBtnText,
      submitButtonTestingContext = _ref.submitButtonTestingContext,
      show = _ref.show,
      target = _ref.target,
      testingContext = _ref.testingContext,
      title = _ref.title,
      edit = _ref.edit,
      hide = _ref.hide,
      showHideModal = _ref.showHideModal,
      onSubmit = _ref.onSubmit;
  return React.createElement(Overlay, {
    testingContext: testingContext,
    position: "center",
    show: show,
    hide: hide,
    edit: edit,
    target: target
  }, React.createElement(S.Modal, null, React.createElement(CardHeader, {
    divider: true,
    onHide: showHideModal
  }, title), React.createElement(S.Content, null, children, React.createElement(S.Footer, null, disabled ? React.createElement(S.Loader, null, React.createElement(Loader, null)) : React.createElement(FormFooter, _extends({
    divider: true,
    disabled: disabled
  }, getSubmitBtnProps(submitBtnText, submitButtonTestingContext, onSubmit), getCancelBtnProps(hide, cancelBtnText), {
    formId: formId
  }))))));
};